class r extends Error{constructor(r){super("GraphQL Error"),this.response=r}}export{r as StorefrontError};
//# sourceMappingURL=storefront-error.js.map
